// //CCMS EXT
export const environment = {
    production: false,
    MVC_URL: 'https://m.lket' + 'est.com/CCMSMVC',
    API_URL: 'https://m.lket' + 'est.com',
    APP_URL: 'https://contributions.lket' + 'est.com',
    APP_NAME: '',
    APPLICATION_ID: 'CCMSEXT',
    MVC_DATA_CONTEXT: 'AppData',
    USE_CREDENTIALS: true,
    OFFLINE_DATABASE_NAME: 'ccms_test_db',
    EXTERNAL_APP: true,
    LGEKU_FX_SERVER: 'https://fx.lk' + 'etest.com/efx'
}; 